import { render, staticRenderFns } from "./DialogReleases.vue?vue&type=template&id=1180c1f6&scoped=true"
import script from "./DialogReleases.vue?vue&type=script&lang=js"
export * from "./DialogReleases.vue?vue&type=script&lang=js"
import style0 from "./DialogReleases.vue?vue&type=style&index=0&id=1180c1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180c1f6",
  null
  
)

export default component.exports